import getSupportedLocale from "../../helpers/getSupportedLocale"
import env from "../../../env"

export default (bucketName, rawLocale) => {
  const locale = getSupportedLocale(rawLocale)
  return `${env.PUBLIC_URL}/locale/web/${locale}/${bucketName}.json`.toLowerCase()
}
